


















import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { TransactionSearchOptions, PageConfig } from "@/types";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import DesignerSearch from "../DesignerSearch.vue";
import { contains } from "@canvas/componentlibrary/src/utils";

export default Vue.extend({
  name: "search-projects",
  data() {
    return {
      search: {
        placeholder: "Search",
        buttonText: "Search",
        isDropdownAvailable: true,
        dropdownOptions: TransactionSearchOptions,
        dropdownSelected: {} as { name: string; display_name: string },
        searchText: "",
      },
      searchDesignerData: {
        name: "",
        display_name: "",
      },
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement",
      isOnMobileDevice: "isOnMobileDevice",
      mobileAddonOption: "mobileAddonOption",
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc",
      breadcrumb: "breadcrumb",
    }),
    isSearchBarVisible() {
      if (
        (this as any).isOnMobileDevice &&
        (this as any).mobileAddonOption.type === "search" &&
        (this as any).mobileAddonOption.state
      ) {
        return true;
      } else {
        return false;
      }
    },
    customRenderer() {
      if (
        (this as any).search.dropdownSelected.name ===
        TransactionSearchOptions[1].name
      ) {
        return DesignerSearch;
      } else {
        return null;
      }
    },
  },
  provide(): any {
    return {
      updateDesigner: (this as any).handleSearchDesignerAction,
      getDesignerData: (this as any).getDesignerSearchData,
    };
  },
  methods: {
    ...mapActions("appModule", ["searchInventoryProducts"]),
    handleSearchClick(searchData: {
      searchText: string;
      option: { name: string; display_name: string };
    }) {
      if (searchData && searchData.option) {
        (this as any).search.searchText = searchData.searchText;
        (this as any).onHistorySearch(searchData);
        if ((this as any).isOnMobileDevice) {
          (this as any).resetMobileFilter();
        }
      }
    },
    handleSearchDesignerAction(value: { name: string; display_name: string }) {
      //update the designer details in searchbar so enable search on that field
      (this as any).searchDesignerData = {
        name: value.name,
        display_name: value.display_name,
      };
      (this as any).search.searchText = value.name.toString();
    },
    handleDropdownSelected(value: { name: string; display_name: string }) {
      //clear the searchText when user dropdown is selected and is user search
      if (
        (this as any).search.dropdownSelected.name ===
        TransactionSearchOptions[1].name
      ) {
        (this as any).search.searchText = "";
        (this as any).searchDesignerData = {
          name: "",
          display_name: "",
        };
      }
      (this as any).search.dropdownSelected = value;
    },
    getDesignerSearchData() {
      return (this as any).searchDesignerData;
    },
    onHistorySearch(searchData: {
      searchText: string;
      option: { name: string; display_name: string };
    }) {
      let pageConfig = JSON.parse(JSON.stringify(PageConfig));
      const apiQuery = {
        [searchData.option.name]: searchData.searchText,
        limit: pageConfig.limit,
        offset: pageConfig.offset,
        ec_id__in: (this as any).selectedEc.name,
      };
      pageConfig.query = encodeQueryParams(apiQuery);
      const routeLink =
        "/incompletevisits/" +
        JSON.stringify({
          search: searchData,
          designerSearch: (this as any).searchDesignerData,
          pageConfig: pageConfig,
        });
      (this as any).$router.push({
        path: routeLink,
      });
    },
    handleInitComponent() {
      (this as any).search.searchText = "";
      (this as any).search.dropdownSelected = (this as any).search.dropdownOptions[0];
      (this as any).searchDesignerData = {
        name: "",
        display_name: "",
      };
      (this as any).onHistorySearch({
        searchText: (this as any).search.searchText,
        option: (this as any).search.dropdownSelected,
      });
    },
    resetMobileFilter() {
      (this as any).$store.commit("uiModule/resetMobileAddonOption", null, {
        root: true,
      });
      (this as any).$store.commit(
        "uiModule/setMobileHeader",
        { title: (this as any).$router.currentRoute.meta.header },
        {
          root: true,
        }
      );
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === "incompletevisits") {
      (this as any).handleInitComponent();
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    (this as any).resetMobileFilter();
    next();
  },
  watch: {
    selectedEc() {
      (this as any).handleInitComponent();
    },
  },
  created() {
    (this as any).$store.commit("appModule/resetProjects", []);
    if (!(this as any).$router.currentRoute.params.searchQuery) {
      (this as any).handleInitComponent();
    } else {
      const paramsJSON = JSON.parse(
        (this as any).$router.currentRoute.params.searchQuery
      );
      (this as any).search.searchText = paramsJSON.search.searchText;
      (this as any).search.dropdownSelected = paramsJSON.search.option;
      if (
        (this as any).search.dropdownSelected.name ===
        TransactionSearchOptions[1].name
      ) {
        (this as any).searchDesignerData = paramsJSON.designerSearch;
      }
    }
  },
});
